<template>
  <v-container fluid class="legal-page pa-0">
    <section class="hero d-flex align-center justify-center">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="9" lg="8">
            <v-card class="legal-card pa-8">
              <v-btn
                text
                color="primary"
                class="mb-4"
                @click="goBack"
              >
                <v-icon left>mdi-arrow-left</v-icon>
                Volver
              </v-btn>

              <div class="text-center mb-6">
                <v-img
                  src="/logo.png"
                  contain
                  height="90"
                  class="mx-auto mb-4"
                />
                <h1 class="font-weight-bold">
                  Política de Cookies de Kalendario
                </h1>
                <p class="effective-date">
                  Fecha de entrada en vigor: 15 de mayo de 2026 | Última actualización: 15 de mayo de 2026
                </p>
              </div>

              <div class="legal-text">
                <h2>1. Introducción</h2>
                <p>
                  En Kalendario, accesible desde
                  <a href="https://kalendario.thevalkiria.com" target="_blank" rel="noopener noreferrer">
                    https://kalendario.thevalkiria.com
                  </a>,
                  utilizamos cookies, almacenamiento local y tecnologías similares para garantizar el funcionamiento del servicio, mantener la seguridad, gestionar la autenticación y, cuando corresponda, analizar el uso del sitio web y la aplicación.
                </p>
                <p>
                  Esta Política de Cookies explica qué son las cookies, qué tipos de tecnologías podemos utilizar, con qué finalidad se usan y cómo puedes gestionar tus preferencias.
                </p>
                <p>
                  Esta política debe leerse junto con nuestra
                  <router-link to="/privacy-policy">Política de Privacidad</router-link>.
                </p>

                <h2>2. ¿Qué son las cookies?</h2>
                <p>
                  Las cookies son pequeños archivos que se descargan o almacenan en el dispositivo del usuario al acceder a un sitio web.
                </p>
                <p>
                  Permiten, entre otras cosas, almacenar y recuperar información sobre la navegación, el dispositivo, la sesión del usuario, sus preferencias o sus interacciones con el servicio.
                </p>
                <p>
                  Además de cookies, Kalendario puede utilizar tecnologías similares, como almacenamiento local del navegador, identificadores técnicos o mecanismos equivalentes necesarios para el funcionamiento del servicio.
                </p>
                <p>
                  En esta política, usamos el término “cookies” para referirnos también a estas tecnologías similares.
                </p>

                <h2>3. Responsable del uso de cookies</h2>
                <p>
                  El responsable del uso de cookies y tecnologías similares en Kalendario es:
                </p>
                <ul>
                  <li><strong>Responsable:</strong> Sorraylla Ramos</li>
                  <li>
                    <strong>Correo electrónico:</strong>
                    <a href="mailto:valkiria.lab.apps@gmail.com">valkiria.lab.apps@gmail.com</a>
                  </li>
                  <li>
                    <strong>Sitio web:</strong>
                    <a href="https://kalendario.thevalkiria.com" target="_blank" rel="noopener noreferrer">
                      https://kalendario.thevalkiria.com
                    </a>
                  </li>
                  <li><strong>País:</strong> España</li>
                </ul>

                <h2>4. Tipos de cookies y tecnologías utilizadas</h2>
                <p>
                  Kalendario puede utilizar las siguientes categorías de cookies o tecnologías similares:
                </p>

                <h3>4.1. Cookies técnicas o necesarias</h3>
                <p>
                  Son aquellas necesarias para que el sitio web, la aplicación y sus funciones básicas puedan operar correctamente.
                </p>
                <p>Estas cookies permiten, entre otras cosas:</p>
                <ul>
                  <li>Gestionar el inicio de sesión del usuario.</li>
                  <li>Mantener la sesión activa.</li>
                  <li>Proteger el acceso a la cuenta.</li>
                  <li>Recordar configuraciones técnicas esenciales.</li>
                  <li>Garantizar la seguridad del servicio.</li>
                  <li>Permitir el funcionamiento básico de calendarios, eventos y grupos.</li>
                </ul>
                <p>
                  Ejemplos: tokens de autenticación, identificadores técnicos de sesión, almacenamiento local necesario para mantener la sesión, preferencias técnicas imprescindibles y elementos de seguridad asociados a Firebase Authentication.
                </p>
                <p>
                  Estas cookies son necesarias para prestar el servicio solicitado por el usuario y no requieren consentimiento previo, aunque el usuario puede bloquearlas desde su navegador. Si se bloquean, algunas funciones de Kalendario podrían no funcionar correctamente.
                </p>

                <h3>4.2. Cookies de preferencias</h3>
                <p>
                  Son aquellas que permiten recordar ciertos ajustes básicos del usuario para mejorar su experiencia dentro del servicio.
                </p>
                <p>
                  Pueden utilizarse, por ejemplo, para recordar idioma seleccionado, configuración visual, preferencias simples de uso o ajustes básicos de la interfaz.
                </p>
                <p>
                  Cuando la normativa aplicable lo exija, se solicitará el consentimiento del usuario antes de utilizarlas.
                </p>

                <h3>4.3. Cookies analíticas o de medición</h3>
                <p>
                  Kalendario puede utilizar servicios de análisis proporcionados por Google Firebase o Google Analytics para obtener información agregada sobre el uso del servicio.
                </p>
                <p>
                  Estas tecnologías nos ayudan a entender cómo se utiliza Kalendario, medir interacciones, detectar errores, mejorar funciones, optimizar la experiencia de usuario y analizar métricas agregadas de uso.
                </p>
                <p>
                  Los datos tratados pueden incluir información técnica como tipo de dispositivo, sistema operativo, navegador, idioma, eventos de uso, interacciones dentro de la aplicación, métricas agregadas y datos técnicos similares.
                </p>
                <p>
                  Las cookies o tecnologías analíticas no esenciales solo se utilizarán cuando sea legalmente aplicable y, cuando sea necesario, tras obtener el consentimiento previo del usuario.
                </p>
                <p>
                  No utilizamos cookies analíticas para vender datos personales ni para tomar decisiones automatizadas con efectos jurídicos o significativamente similares sobre el usuario.
                </p>

                <h2>5. Cookies de terceros</h2>
                <p>
                  Kalendario utiliza servicios proporcionados por Google, en particular Firebase y, en su caso, Google Analytics.
                </p>
                <p>
                  Estos servicios pueden utilizar cookies, identificadores técnicos, almacenamiento local u otras tecnologías similares gestionadas por Google.
                </p>
                <p>
                  Los servicios utilizados pueden incluir Firebase Hosting, Firebase Authentication, Cloud Firestore y Firebase Analytics.
                </p>
                <p>
                  Google puede tratar datos en servidores ubicados fuera del Espacio Económico Europeo. Cuando sea aplicable, estas transferencias se realizan conforme a mecanismos legalmente reconocidos, como cláusulas contractuales tipo, decisiones de adecuación u otras garantías previstas por la normativa de protección de datos.
                </p>

                <h2>6. Base jurídica para el uso de cookies</h2>
                <p>
                  La base jurídica dependerá del tipo de cookie o tecnología utilizada:
                </p>
                <ul>
                  <li><strong>Cookies técnicas o necesarias:</strong> se utilizan para prestar el servicio solicitado por el usuario y permitir el funcionamiento básico de Kalendario. No requieren consentimiento previo.</li>
                  <li><strong>Cookies de preferencias:</strong> pueden basarse en el consentimiento del usuario cuando no sean estrictamente necesarias.</li>
                  <li><strong>Cookies analíticas o de medición:</strong> se utilizarán con consentimiento del usuario cuando así lo exija la normativa aplicable.</li>
                </ul>
                <p>
                  El usuario puede retirar o modificar su consentimiento en cualquier momento.
                </p>

                <h2>7. Gestión del consentimiento</h2>
                <p>
                  Al acceder al sitio web, el usuario podrá aceptar, rechazar o configurar el uso de cookies no necesarias mediante el banner o panel de configuración de cookies, cuando esté disponible.
                </p>
                <p>
                  El usuario podrá aceptar todas las cookies, rechazar las cookies no necesarias, configurar sus preferencias por categorías y retirar o modificar su consentimiento posteriormente.
                </p>
                <p>
                  Las cookies técnicas o necesarias no pueden desactivarse desde el panel de consentimiento, ya que son imprescindibles para el funcionamiento del servicio. No obstante, el usuario puede bloquearlas desde la configuración de su navegador, aunque esto puede afectar al correcto funcionamiento de Kalendario.
                </p>
                <p>
                  Si todavía no está disponible un panel específico de configuración de cookies, el usuario puede gestionar o retirar su consentimiento eliminando o bloqueando las cookies desde la configuración de su navegador.
                </p>

                <h2>8. Cómo desactivar o eliminar cookies desde el navegador</h2>
                <p>
                  El usuario puede permitir, bloquear o eliminar las cookies instaladas en su dispositivo mediante la configuración del navegador que utilice.
                </p>
                <p>
                  El bloqueo o eliminación de cookies técnicas o necesarias puede impedir el inicio de sesión, afectar a la autenticación o limitar el funcionamiento de calendarios, eventos, grupos y otras funciones de Kalendario.
                </p>

                <h2>9. Periodo de conservación</h2>
                <p>
                  El periodo de conservación de las cookies dependerá de su tipo y finalidad.
                </p>
                <ul>
                  <li><strong>Cookies técnicas o necesarias:</strong> se conservarán durante el tiempo necesario para mantener la sesión, garantizar la seguridad o permitir el funcionamiento del servicio.</li>
                  <li><strong>Cookies de preferencias:</strong> se conservarán durante el tiempo necesario para recordar la configuración seleccionada por el usuario o hasta que el usuario las elimine.</li>
                  <li><strong>Cookies analíticas:</strong> se conservarán durante el periodo configurado en Firebase/Google Analytics o hasta que el usuario retire su consentimiento, cuando corresponda.</li>
                </ul>
                <p>
                  Cuando sea posible, Kalendario procurará limitar la conservación de los datos al tiempo estrictamente necesario para cumplir las finalidades descritas en esta política.
                </p>

                <h2>10. Transferencias internacionales</h2>
                <p>
                  El uso de servicios de Google Firebase o Google Analytics puede implicar el tratamiento de datos en países situados fuera del Espacio Económico Europeo.
                </p>
                <p>
                  Cuando sea aplicable, dichas transferencias se realizarán conforme a garantías adecuadas previstas por la normativa de protección de datos, como cláusulas contractuales tipo, decisiones de adecuación u otros mecanismos legalmente reconocidos.
                </p>

                <h2>11. Actualización de la Política de Cookies</h2>
                <p>
                  Kalendario podrá actualizar esta Política de Cookies para adaptarla a cambios legales, técnicos o funcionales, así como a modificaciones en los servicios de terceros utilizados.
                </p>
                <p>
                  Cuando se realicen cambios importantes, se actualizará la fecha de “Última actualización” y, si corresponde, se informará al usuario mediante el sitio web, la aplicación o el banner de cookies.
                </p>
                <p>
                  Te recomendamos revisar esta Política de Cookies periódicamente.
                </p>

                <h2>12. Contacto</h2>
                <p>
                  Para cualquier pregunta sobre esta Política de Cookies o sobre el uso de cookies y tecnologías similares en Kalendario, puedes contactar con nosotros en:
                </p>
                <ul>
                  <li>
                    <strong>Sitio web:</strong>
                    <a href="https://kalendario.thevalkiria.com" target="_blank" rel="noopener noreferrer">
                      https://kalendario.thevalkiria.com
                    </a>
                  </li>
                  <li>
                    <strong>Email:</strong>
                    <a href="mailto:valkiria.lab.apps@gmail.com">valkiria.lab.apps@gmail.com</a>
                  </li>
                  <li><strong>Responsable:</strong> Sorraylla Ramos</li>
                </ul>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </v-container>
</template>

<script>
export default {
  name: 'CookiesPolicy',
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
        return;
      }

      this.$router.push("/");
    }
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
}

.hero {
  min-height: 100vh;
}

.legal-card {
  border-radius: 10px;
  box-shadow: 0 30px 70px rgba(0, 0, 0, 0.25);
}

.effective-date {
  color: #666;
  font-size: 0.95rem;
  margin-top: 12px;
}

.legal-text p,
.legal-text li {
  color: #444;
  line-height: 1.7;
}

.legal-text p {
  margin-bottom: 16px;
}

.legal-text ul {
  margin-bottom: 16px;
  padding-left: 22px;
}

.legal-text li {
  margin-bottom: 8px;
}

.legal-text h2 {
  margin-top: 28px;
  margin-bottom: 10px;
  font-size: 1.35rem;
  font-weight: 700;
}

.legal-text h3 {
  margin-top: 22px;
  margin-bottom: 8px;
  color: #333;
  font-size: 1.08rem;
  font-weight: 700;
}

.legal-text a {
  color: #4f46e5;
  font-weight: 600;
  text-decoration: none;
  overflow-wrap: anywhere;
}

.legal-text a:hover {
  text-decoration: underline;
}
</style>
